import React, { useState, useEffect } from "react";
import { MultiSelect } from 'primereact/multiselect';
import { setLocations } from 'src/redux/actions';
import { useDispatch, useSelector } from 'react-redux';

export default function VirtualScrollDemo(props) {
  const [selectAll, setSelectAll] = useState(true);
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.filter.locations) || [];



  const items = Array.from(Object.keys(props.remote_source), key => ({
    label: props.remote_source[key],
    value: key,
  }));
  return (
    <div className="card flex justify-content-center" style={{border:'none'}}>
            <label className="control-label justify-content-start" htmlFor={props.id}>
            {props.label} 
          </label>
      <MultiSelect
        value={locations}
        options={items}
        onChange={(e) => dispatch(setLocations(e.value))}
        filter
        virtualScrollerOptions={{ itemSize: 30, height: '100px'  }}
        maxSelectedLabels={1}
        style={{ height: '100%' }} delay={200}
        placeholder={"Select " + props.label}
        className="w-full md:w-20rem"
      />
    </div>
  );
}
